export default __webpack_public_path__ + "static/media/blue-arrow.de6371d0.svg";